import React from "react";

const Loading: React.FC<{ fullScreen?: boolean }> = ({ fullScreen = false }) => (
  <div className={`flex w-full flex-col items-center justify-center gap-3 ${fullScreen ? "min-h-screen bg-white dark:bg-slate-950" : "min-h-[50vh]"}`}>
    <div className="relative grid w-24 h-24 place-items-center">
      <div className="absolute inset-0 border-4 rounded-full animate-spin border-primary-100 border-r-primary-400 border-t-primary-600 dark:border-slate-800 dark:border-r-primary-400 dark:border-t-primary-500" />
      <img src="/images/logo/smalllogo.png" alt="One Place Deal" className="object-contain h-14 w-14" />
    </div>

  </div>
);

export default Loading;
